var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jzbWrap" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _vm.jzb_attribute === "private" ||
          _vm.jzb_attribute === "private-public"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "对私交易明细", name: "person" } },
                [
                  _vm.person
                    ? _c("trans-detail", { attrs: { type: 2 } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.jzb_attribute === "public" ||
          _vm.jzb_attribute === "private-public"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "对公交易明细", name: "business" } },
                [
                  _vm.business
                    ? _c("trans-detail", { attrs: { type: 1 } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-063a7d64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063a7d64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/trans-detail-tab.vue
// module id = null
// module chunks = 